<template>
  <div class="pc page" v-if="showPage">
    <Head :extras="extras" :logo="defaultRess.pc.logo" />

    <Banner :extras="extras" />

    <div class="container">
      <div
        class="file-list"
        :class="{ 'multi-col': extraItem.extras('listType.model') == '2' }"
      >
        <div class="no-data" v-if="fileList.length == 0">
          暂无数据
        </div>
        <div
          class="list-item"
          v-for="file in fileList"
          :key="file.fileId"
          :class="{
            'list-item__cover': extraItem.extras('listCoverType.model') == 1
          }"
        >
          <div
            class="item-cover"
            v-if="extraItem.extras('listCoverType.model') == 1"
          >
            <img :src="file.coverUrl" alt="" />
          </div>
          <div class="item-icon" v-else>
            <img :src="file.iconUrl" alt="" />
          </div>
          <div
            class="item-content"
            :class="{ icon: extraItem.extras('listCoverType.model') != 1 }"
          >
            <div
              class="item-title"
              :title="file.name"
              :style="{
                color: extraItem.extras('listTitle.color'),
                fontSize: pxOrVw(extraItem.extras('listTitle.size')),
                fontWeight:
                  extraItem.extras('listTitle.weight') == 'default'
                    ? '500'
                    : extraItem.extras('listTitle.weight')
              }"
            >
              {{ file.name }}
            </div>
            <!-- <div class="item-summary">
              {{ file.descInfo }}
            </div> -->
            <div class="item-foot">
              <div
                class="item-date"
                v-if="extraItem.extras('fileInfo.display') == 1"
              >
                {{ file.dateText }} <span class="icontemp chakan1"></span>
                {{ file.previewCount }} <span class="icontemp xiazai1"></span
                >{{ file.downloadCount }} <span class="icontemp wendang"></span
                >{{ file.sizeText }}
              </div>
              <div class="item-button">
                <div
                  class="button"
                  :style="{
                    color: extraItem.extras('themecolor.bgcolor'),
                    borderColor: extraItem.extras('themecolor.bgcolor')
                  }"
                  v-if="extraItem.extras('previewBtnName.display') == 1"
                  @mouseenter="setThemeColor"
                  @mouseleave="backThemeColor"
                  @click="onDetails(file)"
                >
                  {{ extraItem.extras("previewBtnName.model") || "预览" }}
                </div>
                <div
                  class="button"
                  :style="{
                    color: extraItem.extras('themecolor.bgcolor'),
                    borderColor: extraItem.extras('themecolor.bgcolor')
                  }"
                  v-if="extraItem.extras('downloadBtnName.display') == 1"
                  @mouseenter="setThemeColor"
                  @mouseleave="backThemeColor"
                  @click="onDownloadFile(file, folderData.downloadType)"
                >
                  {{ extraItem.extras("downloadBtnName.model") || "下载" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="file-list-footer">
        <a-pagination
          v-show="totalNum > 10"
          v-model="currentPageNum"
          show-size-changer
          show-less-items
          :total="totalNum"
          :page-size="pageSize"
          :page-size-options="pageSizeOptions"
          :show-total="total => `共计 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="onPaginationChange"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
            <span v-if="props.value === '50'">全部</span>
          </template>
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins/index.js";
import mixinTemplate from "@/mixins/template.js";
import { URLS } from "fire-wind-water";
import { isSetting } from "@/common/sbase.js";
import { ck } from "fire-wind-water";
import Head from "@/components/head";
import Banner from "@/components/banner";

export default {
  name: "PcFileList",
  props: ["folderId"],
  mixins: [mixin, mixinTemplate],
  components: { Head, Banner },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      accKey: URLS.getURL("accKey"),
      folderData: {},
      // 分页
      totalNum: 0,
      currentPageNum: 1,
      pageSize: 10,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      fileList: [],
      sessParam: "",
      // 是否可以查看页面（限制微信查看）
      showPage: false
    };
  },
  methods: {
    init() {
      this.service
        .getReleaseFile({
          fileId: this.folderId
        })
        .subscribe(data => {
          if (data.result !== 0) {
            this.$antMessage.warning("未获取到对应文件");
            console.log("未获取到对应文件");
            return;
          }
          if (data.content && data.content.schemaId) {
            let memberInfo = ck.cookie(
              "smarketMember_" + data.content.schemaId
            );
            this.sessParam = memberInfo ? memberInfo.session : "";
          }
          this.folderData = this.cookFolderData(data.content);
          // console.log(JSON.stringify(this.folderData, null, 2))

          // 是否限制微信端
          if (this.folderData.openType == 1 && !window.$ua.isWeChat) {
            this.showPage = false;
            this.$antMessage.info("请在微信端浏览本页面！", 0);
            window.$sk && window.$sk.loading.hide();
            return;
          }

          // 权限验证
          if (!this.verifyPermission(this.folderData)) return;

          this.showPage = true;
          this.getContact(this.folderData.tenantId);

          this.initConfig(this.folderData.pcConfigId, this.folderData.tenantId);
          this.loadFileList();
        });
    },
    loadFileList(pageNum) {
      let loadPageNum = pageNum ? pageNum : 1;
      let memberInfo = ck.cookie("smarketMember_" + this.folderData.schemaId);
      this.service
        .getReleaseFileList({
          folderId: this.folderId,
          accKey: this.accKey,
          num: this.pageSize,
          start: this.pageSize * (loadPageNum - 1),
          userSess: this.sessParam,
          sess: memberInfo? memberInfo.session : ""
        })
        .subscribe(data => {
          this.totalNum = parseInt(data.content.total);
          this.fileList = this.cookFileList(data.content.items);
          // console.log(JSON.stringify(this.fileList, null, 2))
        });
    },
    onPaginationChange(pageNum) {
      this.loadFileList(pageNum);
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
      this.currentPageNum = 1;
      this.loadFileList();
    },
    setThemeColor(e) {
      e.target.style.backgroundColor = this.extraItem.extras(
        "themecolor.bgcolor"
      );
    },
    backThemeColor(e) {
      e.target.style.backgroundColor = "";
    },
    onDetails(file) {
      if (this.isSetting) return;
      if (file.preview.type == 2 || file.preview.type == 3) {
        window.open(file.detailUrl);
      } else {
        if (file.previewUrl) {
          // window.open(file.previewUrl); // 新打开一个页面用ifrem包含url
          let { href } = this.$router.resolve({
            path: "/pc/filePreview",
            query: {
              fileId: file.fileId
            }
          });
          // window.$sk.goto(href);
          let urlHref = window.location.href.split('#')[0] + href;
          window.open(urlHref);
          this.interactionPreview(file);
        } else {
          window.$sk && window.$sk.alert("该文件不支持预览");
        }
      }
    }
  },
  created() {
    if (isSetting) {
      this.showPage = true;
      this.initMockFileList();
      return;
    }
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.pc {
  .header-banner-image {
    width: 100%;
  }
  .file-list {
    // min-height: 500px;
    padding-top: 64px;
    .file-item {
      display: flex;
      padding: 28px 0;
      border-bottom: solid 1px rgba(238, 238, 238);
      .file-icon {
        width: 180px;
        margin-top: 10px;
        background-repeat: no-repeat;
        background-position: 50% 0;
        background-size: 100px auto;
      }
      .file-cover {
        width: 260px;
        height: 130px;
        margin-top: 10px;
        margin-right: 30px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
      .file-content {
        flex: 1;
        flex-direction: column;
        text-align: start;
        overflow: hidden;
        .title {
          font-size: 18px;
          font-weight: bold;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .desc-info {
          max-height: 50px;
          margin: 18px 0;
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow-wrap: break-word;
          overflow: hidden;
        }
        .stat-info {
          color: rgb(153, 153, 153);
          display: flex;
          margin: 18px 0;
          .date {
            margin-right: auto;
          }
          .preview {
            margin: 0 24px;
          }
          i {
            padding-right: 8px;
          }
        }
        .file-action {
          display: flex;
          align-items: center;
          .action-btn {
            display: inline-block;
            max-width: 120px;
            min-width: 84px;
            height: 26px;
            line-height: 24px;
            text-align: center;
            color: $color-base;
            padding: 0 5px;
            margin-right: 16px;
            border: solid 1px $color-base;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            i {
              padding-right: 8px;
            }
          }
        }
      }
    }
  }
  .file-list-footer {
    display: flex;
    font-size: 18px;
    font-weight: bold;
    padding: 50px 0;
    justify-content: flex-end;
  }

  .list-item {
    position: relative;
    height: 150px;
    display: flex;
    justify-content: space-between;
    padding: 25px 30px 30px 30px;
    margin-bottom: 30px;
    box-shadow: 0px 0px 10px 0px rgba(222, 222, 222, 0.43);
    border-radius: 2px;
    animation: opacityAnimate 0.3s ease-in-out;

    .item-cover {
      position: relative;
      width: 220px;
      flex: 0 0 220px;
      height: 100%;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      //background: #cbdbf2;

      img {
        display: block;
        width: 100%;
      }
    }
    .item-icon {
      position: relative;
      width: 46px;
      flex: 0 0 46px;
      padding-top: 4px;
      height: 100%;
      img {
        width: 100%;
        // height: 100%;
      }
    }
    .item-content {
      //   width: 648px;
      margin-left: 30px;
      flex: 1;
      position: relative;
      color: #212121;
      //   &.icon {
      //     width: 800px;
      //     .button {
      //       max-width: 200px;
      //     }
      //   }
      .item-title {
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        height: 48px;
        margin-bottom: 15px;
        @include ellipsis(2);
      }
      .item-summary {
        font-size: 12px;
        opacity: 0.62;
        height: 68px;
        line-height: 24px;
        margin-top: 10px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .item-date {
        font-size: 14px;
        color: #aaaaaa;

        .icontemp {
          margin-left: 16px;
          font-size: 14px;
        }
      }
      .item-button {
        height: 32px;
        color: #1665d8;
        margin-left: auto;
      }
    }
    &.list-item__cover {
      height: 170px;
      padding: 20px 20px 20px 10px;
      .item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }

  .file-list.multi-col {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list-item {
      flex: 0 0 calc(50% - 15px);
      width: calc(50% - 15px);
      &.list-item__cover {
        .item-foot {
          height: auto;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
        }
        .item-date {
          width: 100%;
        }
        .item-button {
          margin-top: 14px;
          .button:first-of-type {
            margin-left: 0;
          }
        }
      }
    }
  }

  .item-foot {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 23px;
    height: 32px;
  }
  .button {
    display: inline-block;

    /*width: 124px;*/
    min-width: 80px;
    margin-left: 10px;
    height: 32px;
    box-sizing: border-box;
    line-height: 30px;
    text-align: center;
    border: 1px solid $blue;
    border-radius: 4px;
    color: $blue;
    font-size: 14px;
    background-color: #ffffff;
    cursor: pointer;
    max-width: 138px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 10px;
    .icontemp {
      font-size: 21px;
      position: relative;
      margin-right: 5px;
      top: 2px;
    }
    &:hover {
      background-color: $blue;
      color: #ffffff !important;
    }
  }
  .no-data {
    // position: relative;
    text-align: center;
    // top: 250px;
    color: #b1b1b1;
    font-size: 18px;
    width: 100%;
    height: 200px;
    line-height: 200px;
  }
}
@keyframes opacityAnimate {
  0% {
    opacity: 0;
    transform: translate(0, -10px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>
